/**
 * 必須のバリデーションチェック
 */
export const getRequiredErrorMessage = (input: string): string | undefined => {
  if (!input) return 'Required fields';
  return undefined;
};

const isValidEmailFormat = (email: string): boolean => {
  // TLDは最低２文字＆数字を含まない
  const reg = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z]{2,})+$/;
  return reg.test(email);
};
/**
 * メールアドレスの必須と入力形式をチェックする
 */
export const getEmailRequiredAndFormatErrorMessage = (email: string): string | undefined => {
  if (!email) {
    return 'Required fields';
  }
  if (!isValidEmailFormat(email)) {
    return 'The input format of Email is incorrect.';
  }

  return undefined;
};
